import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const filteredArticles = selectedCategory === 'all'
    ? articles
    : articles.filter((a) => a.category === selectedCategory);

  const hotArticles = articles.filter((a) => a.isHot && a.isTop).slice(0, 1);
  const featuredArticles = articles.filter((a) => a.isHot && !a.isTop).slice(0, 4);
  const latestArticles = filteredArticles;

  const seoData = {
    title: '黑料在线 - 最新独家黑料内容聚合平台',
    description: '黑料在线为您提供最新、最全的独家黑料内容，涵盖娱乐圈、网红、明星等各类爆料资讯。海量黑料在线实时更新，深度挖掘真相，让您第一时间掌握最劲爆的内幕消息。',
    keywords: '黑料在线,黑料在线最新,独家黑料爆料,明星黑料资讯,网红黑料内幕,娱乐圈黑料,黑料在线聚合',
    canonical: 'https://heiliao-online.com',
  };

  return (
    <>
      <head>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
        <link rel="canonical" href={seoData.canonical} />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoData.canonical} />
        <meta property="og:site_name" content="黑料在线" />
        <meta property="og:locale" content="zh_CN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.title} />
        <meta name="twitter:description" content={seoData.description} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "黑料在线",
            "url": seoData.canonical,
            "description": seoData.description,
            "inLanguage": "zh-CN",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${seoData.canonical}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "黑料在线",
            "url": seoData.canonical,
            "description": seoData.description,
            "foundingDate": "2024",
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "availableLanguage": ["Chinese"]
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": seoData.title,
            "description": seoData.description,
            "url": seoData.canonical,
            "inLanguage": "zh-CN",
            "isPartOf": {
              "@type": "WebSite",
              "name": "黑料在线",
              "url": seoData.canonical
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": seoData.canonical
              }
            ]
          })}
        </script>
      </head>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=dark%20dramatic%20urban%20cityscape%20at%20night%20with%20neon%20red%20and%20warm%20orange%20accents%2C%20mysterious%20atmosphere%2C%20wet%20streets%20reflecting%20lights%2C%20cinematic%20aerial%20view%2C%20modern%20Asian%20megacity%2C%20film%20noir%20aesthetic%2C%20high%20contrast%2C%20foggy%20ambiance%2C%20deep%20shadows%20with%20vibrant%20highlights&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
              alt="黑料在线 - 最新独家爆料资讯平台"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center w-full px-4">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight">
                黑料在线
              </h1>
              <p className="text-base md:text-xl text-white/80 max-w-2xl mb-8 leading-relaxed">
                最新独家黑料内容聚合平台 &mdash; 深度挖掘娱乐圈、网红、明星等各类爆料内幕，实时更新，让您第一时间掌握最劲爆的资讯
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <Link
                  to="/category/yulequan"
                  className="px-8 py-3 rounded-full bg-white text-foreground-950 font-semibold text-sm whitespace-nowrap transition-all duration-300 hover:bg-white/90 hover:scale-105"
                >
                  立即浏览
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:bg-white/10 hover:border-white/60"
                >
                  了解我们
                </Link>
              </div>
            </div>
          </section>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 -mt-16 relative z-10 mb-12">
            <div className="bg-background-50 rounded-lg p-2 shadow-sm border border-background-200/70">
              <div className="flex items-center gap-1 flex-wrap px-1 py-1 rounded-full bg-background-100">
                <button
                  onClick={() => setSelectedCategory('all')}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    selectedCategory === 'all'
                      ? 'bg-foreground-950 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/70'
                  }`}
                >
                  <i className="ri-fire-line mr-1.5"></i>
                  全部
                </button>
                {categories.map((cat) => (
                  <button
                    key={cat.slug}
                    onClick={() => setSelectedCategory(cat.slug)}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                      selectedCategory === cat.slug
                        ? 'bg-foreground-950 text-background-50'
                        : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/70'
                    }`}
                  >
                    <i className={`${cat.icon} mr-1.5`}></i>
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>
          </section>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 mb-14">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2">
                {hotArticles.length > 0 && (
                  <ArticleCard article={hotArticles[0]} variant="large" />
                )}
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                  <h2 className="text-lg font-bold text-foreground-950 whitespace-nowrap">热点速递</h2>
                </div>
                {featuredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} variant="compact" />
                ))}
              </div>
            </div>
          </section>

          <section className="max-w-[1280px] mx-auto px-4 md:px-6 mb-16">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <div className="w-1 h-5 bg-foreground-950 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-950 whitespace-nowrap">
                  {selectedCategory === 'all' ? '最新爆料' : categories.find((c) => c.slug === selectedCategory)?.name}
                </h2>
              </div>
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} variant="default" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20 text-foreground-400">
                <i className="ri-inbox-line text-5xl mb-4 block"></i>
                <p className="text-lg">该分类暂无内容</p>
              </div>
            )}
          </section>

          <section className="bg-background-100 py-16">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">为什么选择黑料在线</h2>
                <p className="text-foreground-500 max-w-2xl mx-auto">我们致力于为用户提供最快、最全、最真实的娱乐爆料资讯</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-flashlight-line', title: '实时更新', desc: '7x24小时全天候追踪最新爆料，第一时间为您呈现' },
                  { icon: 'ri-shield-check-line', title: '独家信源', desc: '拥有广泛的独家信息渠道，确保内容真实可靠' },
                  { icon: 'ri-stack-line', title: '海量内容', desc: '涵盖娱乐圈、网红、明星等多个领域，内容丰富' },
                  { icon: 'ri-user-heart-line', title: '用户至上', desc: '以用户体验为核心，持续优化产品与服务' },
                ].map((item, idx) => (
                  <div key={idx} className="bg-background-50 rounded-lg p-6 text-center">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100">
                      <i className={`${item.icon} text-xl text-foreground-950`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}